// Los selects para elegir preventor solo ofrecen activos (SMP-428). El GET de preventores devuelve
// también a los inactivos, con su activo efectivo, para filtros e historial.
export const soloPreventoresActivos = <T extends { activo?: boolean | null }>(
    preventores?: T[] | null
): T[] => (preventores ?? []).filter((preventor) => preventor.activo === true);
